import React, { useEffect, useState } from 'react';
import { Panel, MTable, PaginationTable, Pagination} from '../../../../Components';
import { Grid,Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import UserSevicesApi from '../../../../Redux/Actions/UserAction';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './Customer.styles';
import { useSnackbar } from 'notistack';
export const UserCustomerList = ({customerid}) => {
    const { formatMessage } = useIntl();
    const tableRef = React.createRef();
    const dispatch:any = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const classes = useStyles();
    const {userList,apiToken,currentUser} = useSelector((state:any) => ({
        userList:state?.UserReducer?.userList,
        apiToken:state?.UserReducer?.apiToken,
        currentUser:state?.UserReducer?.currentUser,
      }))
    useEffect(() => {
       dispatch(UserSevicesApi?.UserListData(currentUser,apiToken,enqueueSnackbar))
    }, [])
    const bodydata = [
        { title:formatMessage({id:"customer.update.name", defaultMessage:"Name"}), field: "firstName" },
        { title: formatMessage({id:"customer.update.email", defaultMessage:"Email"}), field: "email" },
    ]
    const countRow = userList.filter((item:any)=>item.customerId == customerid)
      const {pagination} = Pagination() 
    return (
        <Panel titleKey="organization.users">
            <MTable
                hideToolbar
                tableRef={tableRef}
                columns={bodydata} data={userList == undefined?[]:userList?.filter((item:any)=>item?.customerId == customerid)}
                onPageChange={(page)=>setPage(page)}
                onRowsPerPageChange={(pageSize:any)=> setRowsPerPage(parseInt(pageSize, 10))}
                localization={{pagination}}
                components={{
                    Pagination: (props: any) => (
                        <Grid component="td" container>
                            <Grid item xs={6}>
                                <Typography className={classes.total}>
                                    {formatMessage({ id: 'component.mtable.total' })}
                                    &nbsp;{countRow.length}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} >
                            <PaginationTable
                             props={ props}
                             page = {page}
                             rowsPerPage={rowsPerPage}
                            count={countRow}
                            />
                            </Grid>
                        </Grid>
                    ),
                }}
            />
        </Panel>
    )
}